import { Button } from '@cocoonspace/ui/components/button'
import { ButtonGroup } from '@cocoonspace/ui/components/button-group'
import { CalendarDaysIcon, Columns3Icon } from 'lucide-react'

import { useSchedulerCalendar } from './provider'

export const ViewPicker = () => {
	const { view, setView } = useSchedulerCalendar()

	return (
		<ButtonGroup className='max-md:hidden'>
			<Button
				type='button'
				variant={view === 'week' ? 'default' : 'outline'}
				size='sm'
				icon
				className='border-border'
				onClick={() => setView('week')}
			>
				<Columns3Icon />
			</Button>

			<Button
				type='button'
				variant={view === 'month' ? 'default' : 'outline'}
				size='sm'
				icon
				className='border-border'
				onClick={() => setView('month')}
			>
				<CalendarDaysIcon />
			</Button>
		</ButtonGroup>
	)
}
